import icn_linebar_chart from "assets/images/icons/icn_linebar_chart.svg";
import icn_info_solid from "assets/images/icons/icn_Info_solid.svg";
import { ReactComponent as Clock } from "assets/images/icons/icn_display_clock.svg";
import { useTheme } from "@mui/material/styles";

import React, { useState } from "react";
import {
  Box,
  Typography,
  Tooltip,
  tooltipClasses,
  CircularProgress,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import WiredLinkDegradationChart from "../../charts/WiredLinkDegradationChart";

const WiredLinkDegradation = ({
  wiredLinkDegradationApiChartData,
  wiredLinkDegradationChartSeriesData = [],
  onClick,
  loading = false,
}) => {
  const theme = useTheme();
  const isNoData = Number(wiredLinkDegradationApiChartData?.switchCount) === 0;

  return (
    <Box
      onClick={isNoData ? undefined : onClick}
      sx={{
        border: `1px solid ${theme.palette.primary.greyThread}`,
        borderRadius: theme.shape.customBorderRadius[8],
        p: 2.5,
        bgcolor: theme.palette.primary.white,
        mb: 3,
        cursor: onClick && !isNoData ? "pointer" : "default",
        "&:hover":
          onClick && !isNoData
            ? {
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
              }
            : {},
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            component="img"
            src={icn_linebar_chart}
            sx={{ width: "18px", height: "18px", mr: 1 }}
          />

          <Typography
            sx={{
              fontWeight: theme.typography.customFontWeight[2],
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[3],
              mr: 1,
            }}
          >
            Wired Link Degradation
          </Typography>

        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            color: theme.palette.primary.main,
          }}
        >
          <Clock />
          <Typography
            sx={{
              fontSize: theme.typography.customFontSize[2],
              fontWeight: theme.typography.customFontWeight[2],
              ml: 0.5,
            }}
          >
            Last 24 Hours
          </Typography>
        </Box>
      </Box>

      {loading ? (
        <Box
          sx={{
            height: "250px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : isNoData ? (
        <Box
          sx={{
            height: "250px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.greyThird,
              fontSize: theme.typography.customFontSize[2],
            }}
          >
            No data available
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            alignItems: "stretch",
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", lg: 280 },
              pr: { xs: 0, lg: 5 },
              pb: { xs: 3, lg: 0 },
              borderRight: {
                xs: "none",
                lg: `1px solid ${theme.palette.primary.greyThread}`,
              },
            }}
          >
            <Box sx={{ mb: 2.5 }}>
              <Typography
                sx={{
                  fontSize: theme.typography.customFontSize[11],
                  lineHeight: 1.1,
                  fontWeight: theme.typography.customFontWeight[3],
                  color: theme.palette.primary.redPrimary,
                }}
              >
                <Box
                  component="span"
                  sx={{
                    fontSize: theme.typography.customFontSize[6],
                    fontWeight: theme.typography.customFontWeight[3],
                  }}
                >
                  {wiredLinkDegradationApiChartData.degradedPorts}
                </Box>{" "}
                Degraded Port(s)
              </Typography>
            </Box>

            <Box
              sx={{
                borderTop: `1px solid ${theme.palette.primary.greyThread}`,
                pt: 2.5,
              }}
            >
              <Typography
                sx={{
                  fontSize: theme.typography.customFontSize[1],
                  color: theme.palette.primary.greyPrimary,
                  mb: 1,
                  fontWeight: theme.typography.customFontWeight[3],
                }}
              >
                Impacted Switch:{" "}
                <Box
                  component="span"
                  sx={{
                    color: theme.palette.primary.mainHover,
                    fontWeight: theme.typography.customFontWeight[3],
                  }}
                >
                  {wiredLinkDegradationApiChartData.affectedSwitchCount}
                </Box>
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              flex: 1,
              pl: { xs: 0, lg: 5 },
              pt: { xs: 1, lg: 0 },
            }}
          >
            <WiredLinkDegradationChart
              data={wiredLinkDegradationChartSeriesData}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default WiredLinkDegradation;
